<template>
  <div class="home-wrap" ref="homeWrap">
    <el-row>
      <el-col :span="4">
        <div class="space"></div>
      </el-col>
      <el-col :span="16">
        <div class="content">
          <div class="header">
            <div class="header-title">
              <div class="logo">
                <span class="bg-logo"></span>
                <span class="logo-text">Human Resources Department</span>
              </div>
              <div class="date">Date: {{ nowDate }}</div>
            </div>
            <div class="bg-header">Kangaroo Learning  Candidate  Registration Form</div>
          </div>
          <div class="form-content">
            <div class="form-item">
              <form-title title="Basic Information"></form-title>
              <div class="imgbox">
                <div class="uploadimg" style="width: 140px; margin-right: 0">
                  <input
                    @change="handleimg"
                    type="file"
                    name="avatar"
                    ref="imgs"
                    style="
                      opacity: 0;
                      width: 100px;
                      height: 100px;
                      position: absolute;
                      z-index: 1000;
                    "
                    accept="image/png, image/jpg, image/jpeg"
                    id="upload"
                  />
                  <img
                    v-if="!defaultimgflag"
                    :src="imgSrc[0]"
                    style="width: 95px; height: 95px; border-radius: 50px"
                  />
                  <img
                    v-if="defaultimgflag"
                    :src="imgtx"
                    style="width: 95px; height: 95px; border-radius: 50px"
                  />
                  <div style="font-size: 12px; color: #999999;">Add Photo(optional)</div>
                </div>
                <base-info ref="baseInfo"></base-info>
              </div>
            </div>
            <!-- <div class="form-item" v-if="false">
              <form-title title="竞赛背景"></form-title>
              <competition-info ref="competitionInfo"></competition-info>
            </div>-->
            <div class="form-item">
              <form-title
                :hasStar="true"
                title="Education Qualification(Put N.A. if not applicable)"
              ></form-title>
              <edu-info ref="eduInfo"></edu-info>
            </div>
            <div class="form-item">
              <form-title title="Working Experiences(Inc. Internship)"></form-title>
              <work-info ref="workInfo"></work-info>
            </div>
            <div class="form-item">
              <form-title title="Achievement"></form-title>
              <achievement ref="achievement"></achievement>
            </div>
            <div class="form-item">
              <form-title :hasStar="true" title="Job Intention"></form-title>
              <employ ref="employ"></employ>
            </div>
            <div class="form-item" style="margin: 40px 0">
              <form-title :hasStar="true" title="Application Information Source"></form-title>
              <info-source ref="infoSource"></info-source>
            </div>
            <div class="check-wrap" style="display: flex">
              <el-checkbox v-model="isChecked"></el-checkbox>
              <div class="text" style="font-weight: bold; font-size: 13px; padding-left: 10px" @click="isChecked = !isChecked">
                I declare that the information provided above is completely true.<br>
                If this statement and other parts are forged or Faked, I agree and accept that Kangaroo Learning Center Pte. Ltd. may terminate the agreement or contract signed with me at any time
              </div>
            </div>
            <div class="upload-wrap">
              <input
                type="file"
                @change="handleFileChange"
                class="upload-file"
                name="mybtn[]"
                ref="uploadBtn"
                multiple
                accept=".doc, .docx, application/msword, application/pdf"
              />
              <el-button class="upload-btn" size="small" type="primary"
                >Upload  CV (Optional)</el-button
              >
              <div class="upload-tip">
                <p>1. The attachment only supports Word and PDF documents.</p>
                <p>
                  2. The size limit for a single attachment is 2M. If you need to delete the selected attachment, please reselect all attachments!
                </p>
              </div>
            </div>
            <div class="file-list" v-show="fileNames.length">
              <p class="text" v-for="(name, index) in fileNames" :key="index">
                {{ index + 1 + "." + name }}
              </p>
            </div>
          </div>
          <div class="foot-btn-wrap">
            <el-button :disabled="isAble" class="submit-btn" @click="openmodal"
              >Submit</el-button
            >
          </div>
        </div>
      </el-col>
      <el-col :span="4">
        <div class="space"></div>
      </el-col>
    </el-row>
    <check-phone
      ref="checkphone"
      @checkphonesubmit="handleSubmit"
      @handlemodal="handleclose"
      :passcheck="passcheck"
      :visibles="checkphonemodalvisible"
      :phonenum="submitphone"
      :code="code"
    ></check-phone>
    <el-dialog
      title=""
      :visible.sync="showDialog"
      width="230px"
      :show-close="false"
      class="submit-yes"
      :before-close="closeDialog">
      <div slot="title"></div>
      <div style="text-align: center">
        <img src="data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBzdGFuZGFsb25lPSJubyI/PjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+PHN2ZyB0PSIxNjg4NTQ2MDQyNjc3IiBjbGFzcz0iaWNvbiIgdmlld0JveD0iMCAwIDEwMjQgMTAyNCIgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHAtaWQ9IjIzMDMiIHdpZHRoPSI0OCIgaGVpZ2h0PSI0OCIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPjxwYXRoIGQ9Ik01MTIuNjk3MzgzIDYzLjQ0Mzk2MWMtMjQ3LjUzOTgxNiAwLTQ0OC4yMDgxMTUgMjAwLjY2ODI5OS00NDguMjA4MTE1IDQ0OC4yMDgxMTUgMCAyNDcuNTM5ODE2IDIwMC42NjgyOTkgNDQ4LjIwODExNSA0NDguMjA4MTE1IDQ0OC4yMDgxMTUgMjQ3LjUzOTgxNiAwIDQ0OC4yMDgxMTUtMjAwLjY2ODI5OSA0NDguMjA4MTE1LTQ0OC4yMDgxMTVDOTYwLjkwNTQ5OCAyNjQuMTEyMjYgNzYwLjIzNzE5OSA2My40NDM5NjEgNTEyLjY5NzM4MyA2My40NDM5NjF6TTc4Mi42NTA2NzUgMzg2LjMyNDY5NiA0NzIuNTEwMTAyIDcwMy4xODQyOTdjLTEuMDU3MDc1IDEuNTg2MTI1LTIuMjMzODc3IDMuMTAwNjE4LTMuNjIwNDU3IDQuNTA0NTk0LTEyLjE1NTg1NCAxMi4zNDYxODktMzEuODYxNjYyIDEyLjM0NjE4OS00NC4wMjU3MDMgMEwyNzAuODExMzM0IDU1MS4yNjUyODJjLTEyLjE0NjY0NS0xMi4zNDcyMTMtMTIuMTQ2NjQ1LTMyLjM1NDg5NSAwLTQ0LjY4MzY4OCAxMi4xNTQ4MzEtMTIuMzQ3MjEzIDMxLjg2MDYzOC0xMi4zNDcyMTMgNDQuMDE2NDkzIDBMNDQ2LjQxMTcwMSA2NDAuMTczMTk1bDI5Mi4yMTMyNzEtMjk4LjU0OTU4M2MxMi4xNjUwNjQtMTIuMzQ2MTg5IDMxLjg2MTY2Mi0xMi4zNDYxODkgNDQuMDI1NzAzIDBDNzk0Ljc5NzMxOSAzNTMuOTY5OCA3OTQuNzk3MzE5IDM3My45NzY0NiA3ODIuNjUwNjc1IDM4Ni4zMjQ2OTZ6IiBmaWxsPSIjMDU2NEVEIiBwLWlkPSIyMzA0Ij48L3BhdGg+PC9zdmc+">
      </div>
      <div style="padding-top: 15px;text-align: center">
        Submitted Successfully!
      </div>
      <div style="padding-top: 15px; text-align: center">
        <el-button style="width: 100px" @click="closeDialog">OK</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import FormTitle from "@/components/form-title/form-title";
import InfoSource from "@/components/info-source/info-source";
import BaseInfo from "@/components/base-info/base-info";
import Achievement from "@/components/achievement";
// import CompetitionInfo from '@/components/competition-info/competition-info'
import EduInfo from "@/components/edu-info/edu-info";
import WorkInfo from "@/components/work-info/work-info";
import Employ from "@/components/employ/employ";
import CheckPhone from "@/components/modal/check-phone";
import { formatDate, formatDate2 } from "../common/js/util";
import { submitForm } from "../api/submit";
import $ from "jquery";
import moment from "moment";
export default {
  name: "Home",
  computed: {
    nowDate() {
      return moment(new Date()).format('DD/MM/yyyy');
    },
    defaultimgflag() {
      if (this.imgSrc.length) {
        return false;
      } else {
        return true;
      }
    },
  },
  data() {
    return {
      showDialog: false,
      isChecked: false,
      // 提交按钮状态
      isAble: false,
      fileList: [],
      fileFormDataArr: [],
      fileNames: [],
      checkphonemodalvisible: false,
      submitphone: "",
      passcheck: true, //通过验证

      imgNames: [],
      imgFormDataArr: [],
      imgSrc: [],

      imgtx: require("../assets/tx.svg"),
    };
  },
  mounted () {
    const prod = process.env.NODE_ENV
    console.log(prod, '开发环境')
  },
  methods: {
    closeDialog () {
      this.showDialog = false
      window.location.reload();
    },
    //关闭弹窗
    handleclose() {
      this.checkphonemodalvisible = false;
    },
    //上传头像
    handleimg() {
      this.imgNames = [];
      this.imgFormDataArr = [];
      this.imgSrc = [];
      let files = this.$refs.imgs.files;
      for (let i = 0; i < files.length; i++) {
        let index = files[i].type.indexOf("/");
        const imgtype = files[i].type.substring(index);
        if (files[i].size > 3097152) {
          this.$message.error(`Uploaded photo exceeded 3MB, please upload again`);
        } else if (
          imgtype !== "/png" &&
          imgtype !== "/jpg" &&
          imgtype !== "/jpeg"
        ) {
          this.$message.error("Upload Failed");
        } else {
          console.log(files[i]);
          var imgSrcI = this.getObjectURL(files[i]);
          this.imgNames.push(files[i].name);
          this.imgFormDataArr.push(files[i]);
          this.imgSrc.push(imgSrcI);
          console.log(this.imgSrc, "返上传图片");
        }
      }
    },
    getObjectURL(file) {
      var url = null;
      if (window.createObjectURL != undefined) {
        url = window.createObjectURL(file);
      } else if (window.URL != undefined) {
        url = window.URL.createObjectURL(file);
      } else if (window.webkitURL != undefined) {
        url = window.webkitURL.createObjectURL(file);
      }
      return url;
    },
    handleFileChange() {
      this.fileNames = [];
      this.fileFormDataArr = [];
      let files = this.$refs.uploadBtn.files;
      console.log(files, "返回上传简历");
      for (let i = 0; i < files.length; i++) {
        if (files[i].size > 2097152) {
          this.$message.error(`${files[i].name}超过2M`);
        } else {
          this.fileNames.push(files[i].name);
          this.fileFormDataArr.push(files[i]);
        }
      }
    },
    openmodal() {
      // this.isAble = true;
      const scrollEl = this.$refs.homeWrap;
      const validate = this.validateForm();
      console.log()
      if (!validate.res) {
        this.$message.error(validate.msg);
        this.isAble = false;
        return;
      }
      const baseInfoData = this.getBaseInfoData();
      console.log('baseInfoData', baseInfoData)
      this.submitphone = baseInfoData.phone;
      this.code = baseInfoData.areacode;
      this.checkphonemodalvisible = true;
    },
    handleSubmit(val) {
      // this.isAble = true;
      // const scrollEl = this.$refs.homeWrap;
      // const validate = this.validateForm();
      // if (!validate.res) {
      //   this.$message.error(validate.msg);
      //   this.isAble = false;
      //   return;
      // }
      // {
      //
      // }
      this.$refs.baseInfo.changePhone(val);
      const infoSourceData = this.getInfoSourceData();
      const baseInfoData = this.getBaseInfoData();
      // const competitionInfo = this.getCompetitionInfo()
      const eduInfoData = this.getEduInfoData();
      if (eduInfoData.list.length > 0) {
        eduInfoData.qualification = []
        eduInfoData.graduationSchool = []
        eduInfoData.qStartDate = []
        eduInfoData.qEndDate = []
        eduInfoData.qMajor = []
        Object.keys(eduInfoData.list).forEach(i => {
          eduInfoData.qualification.push(eduInfoData.list[i].qualification)
          eduInfoData.graduationSchool.push(eduInfoData.list[i].school)
          eduInfoData.qStartDate.push(eduInfoData.list[i].startDate)
          eduInfoData.qEndDate.push(eduInfoData.list[i].endDate)
          eduInfoData.qMajor.push(eduInfoData.list[i].major)
        })
      }
      const workInfoData = this.getWorkInfoData();
      const achievementData = this.getAchievementData();
      if (achievementData.achievementList.length > 0) {
        achievementData.awardingBody = []
        achievementData.achievementDate = []
        achievementData.awarded = []
        Object.keys(achievementData.achievementList).forEach(i => {
          achievementData.awardingBody.push(achievementData.achievementList[i].awardingBody)
          achievementData.achievementDate.push(achievementData.achievementList[i].achievementDate)
          achievementData.awarded.push(achievementData.achievementList[i].awarded)
        })
      }
      const employInfoData = this.getEmployInfo();
      const checkphoneData = this.getCheckPhoneData();
      console.log('infoSourceData', infoSourceData)
      console.log('baseInfoData', baseInfoData)
      console.log('eduInfoData', eduInfoData)
      console.log('workInfoData', workInfoData)
      console.log('achievement', achievementData)
      console.log('employInfoData', employInfoData)
      console.log('checkphoneData', checkphoneData)
      const data = Object.assign(
        {},
        infoSourceData,
        baseInfoData,
        eduInfoData,
        workInfoData,
        employInfoData,
        checkphoneData,
        achievementData
      ); // 暂时去除的参数 competitionInfo
      let params = new window.FormData();
      // let params = {}
      for (let k in data) {
        if (k !== 'list' && k !== 'achievementList') {
          if (k === 'achievementDate'
            || k === 'awarded'
            || k === 'awardingBody'
            || k === 'graduationSchool'
            || k === 'qEndDate'
            || k === 'qMajor'
            || k === 'qStartDate'
            || k === 'qualification'
          ) {
            params.append(k, JSON.stringify(data[k]))
          } else {
            if (!params[k]) {
              if (k === 'knowUsFrom' && data[k].length > 0) {
                params.append(k, data[k][0]);
              } else {
                params.append(k, data[k]);
              }
              // params[k] = data[k]
            }
          }
        }
      }
      // if (params.knowUsFrom && params.knowUsFrom.length > 0) {
      //   params.knowUsFrom = params.knowUsFrom[0]
      // }
      const fileFormDataArr = this.fileFormDataArr;
      fileFormDataArr.forEach((it) => {
        params.append("mybtn[]", it);
        // params['mybtn[]'] = it
      });
      const imgFormDataArr = this.imgFormDataArr;
      imgFormDataArr.forEach((it) => {
        params.append("avatar", it);
        // params.avatar = it
      });
      this.onSubmitData(params);
    },
    onSubmitData(params) {

      submitForm(params).then((response) => {
        if (response.code === "10000") {
          this.checkphonemodalvisible = false;
          this.$refs.checkphone.submitFlag(true)
          this.passcheck = true;
          // this.$message({
          //   type: "success",
          //   message: "简历提交成功!",
          //   onClose: () => {
          //     // window.location.replace("https://kangaroo.study/");
          //   },
          // });
          this.showDialog = true
        } else {
          this.$refs.checkphone.buttonFlag = false
          this.passcheck = false;
          this.$message.error(response.msg);
          this.$refs.checkphone.submitFlag(false)
        }
      }).catch(e => {
        this.$refs.checkphone.submitFlag('error')
      });
    },
    getCheckPhoneData() {
      const { checkphone } = this.$refs;
      let checkphonedata = {
        vercode: "",
        newphone: "",
      };
      const { vercode, phone } = checkphone;
      return (checkphonedata = {
        ...checkphonedata,
        vercode: vercode,
        newphone: phone,
      });
    },
    getInfoSourceData() {
      const { infoSource } = this.$refs;
      let infoSourceData = {
        knowUsFrom: [],
        knowUsFromOther: "",
        innerSourcePerson: "",
        innerSourcePhone: "",
        recommendationcode: "",
      };
      const {
        checkedCities,
        otherInfo,
        innerSourcePhone,
        innerSourcePerson,
        recommendationcode,
      } = infoSource;
      return (infoSourceData = {
        ...infoSourceData,
        knowUsFrom: [checkedCities],
        knowUsFromOther: otherInfo,
        innerSourcePerson,
        innerSourcePhone,
        recommendationcode,
      });
    },
    getBaseInfoData() {
      const { baseInfo } = this.$refs;
      let baseInfoData = {
        uname: "",
        phone: "",
        email: "",
        residentialAddress: "",
      };
      const {
        name,
        telephone,
        email,
        residentialAddress,
        telTypeValue
      } = baseInfo;
      return (baseInfoData = {
        uname: name,
        phone: telephone,
        email,
        residentialAddress,
        areacode: telTypeValue
      });
    },
    getCompetitionInfo() {
      const { competitionInfo } = this.$refs;
      console.log(competitionInfo);
      let competitionInfoData = {
        prize: "",
        prizeType: "",
      };
      const {
        competitionType,
        competitionLevel,
        competitionType_1,
        competitionLevel_1,
        competitionType_2,
        competitionLevel_2,
        competitionType_3,
        competitionLevel_3,
        competitionType_4,
        competitionLevel_4,
      } = competitionInfo;
      let prize = [];
      if (competitionLevel) {
        prize.push(competitionLevel);
      }
      if (competitionLevel_1) {
        prize.push(competitionLevel_1);
      }
      if (competitionLevel_2) {
        prize.push(competitionLevel_2);
      }
      if (competitionLevel_3) {
        prize.push(competitionLevel_3);
      }
      if (competitionLevel_4) {
        prize.push(competitionLevel_4);
      }
      if (prize.length > 1) {
        prize = prize.join("@@@");
      } else {
        prize = prize.join("");
      }
      let prizeType = [];
      const types = [
        competitionType,
        competitionType_1,
        competitionType_2,
        competitionType_3,
        competitionType_4,
      ];
      for (let i = 0; i < types.length; i++) {
        if (types[i]) {
          prizeType.push(types[i]);
        }
      }
      if (prizeType.length > 1) {
        prizeType = prizeType.join("@@@");
      } else {
        prizeType = prizeType.join("");
      }
      return (competitionInfoData = {
        ...competitionInfoData,
        prize,
        prizeType,
      });
    },
    getEduInfoData() {
      const { eduInfo } = this.$refs;
      // const {
      //   highStartTime,
      //   highEndTime,
      //   graduHSchool,
      //   departmentHMajor,
      //   middleStartTime,
      //   middleEndTime,
      //   graduMSchool,
      //   departmentMMajor,
      //   lowStartTime,
      //   lowEndTime,
      //   graduLSchool,
      //   highestStartTime,
      //   highestEndTime,
      //   graduHESchool,
      //   departmentHEMajor,
      // } = eduInfo;
      // const eduInfoData = {
      //   MstAndDctStart: formatDate2(highStartTime) || "",
      //   MstAndDctEnd: formatDate2(highEndTime) || "",
      //   MstAndDctInstitution: graduHSchool,
      //   MstAndDctMajor: departmentHMajor,
      //   undergraduateStart: formatDate2(middleStartTime) || "",
      //   undergraduateEnd: formatDate2(middleEndTime) || "",
      //   undergraduateInstitution: graduMSchool,
      //   undergraduateMajor: departmentMMajor,
      //   highschoolStart: formatDate2(lowStartTime) || "",
      //   highschoolEnd: formatDate2(lowEndTime) || "",
      //   highschoolInstitution: graduLSchool,
      //   MstStart: formatDate2(highestStartTime) || "",
      //   MstEnd: formatDate2(highestEndTime) || "",
      //   MstInstitution: graduHESchool,
      //   MstEduBckgrnd: departmentHEMajor,
      // };
      const {
        degreeSchool,
        degreeStartDate,
        degreeEndDate,
        degreeMajor,
        diplomaSchool,
        diplomaStartDate,
        diplomaEndDate,
        diplomaMajor,
        aLevelSchool,
        aLevelStartDate,
        aLevelEndDate,
        aLevelMajor,
        list
      } = eduInfo;
      return {
        degreeSchool,
        degreeStartDate,
        degreeEndDate,
        degreeMajor,
        diplomaSchool,
        diplomaStartDate,
        diplomaEndDate,
        diplomaMajor,
        aLevelSchool,
        aLevelStartDate,
        aLevelEndDate,
        aLevelMajor,
        list
      };
    },
    getAchievementData () {
      const { achievement } = this.$refs;
      console.log('achievement', achievement)
      const {
        achievementList
      } = achievement
      return {
        achievementList
      }
    },
    getWorkInfoData() {
      const { workInfo } = this.$refs;
      const {
        oneStartTime,
        oneEndTime,
        oneWorkPlace,
        oneWorkContent,
        twoStartTime,
        twoEndTime,
        twoWorkPlace,
        twoWorkContent,
        threeStartTime,
        threeEndTime,
        threeWorkPlace,
        threeWorkContent,
        fourStartTime,
        fourEndTime,
        fourWorkPlace,
        fourWorkContent,
      } = workInfo;
      const workInfoData = {
        // oneStartTime: formatDate(oneStartTime) || "",
        // twoStartTime: formatDate(twoStartTime) || "",
        // threeStartTime: formatDate(threeStartTime) || "",
        // oneEndTime: formatDate(oneEndTime) || "",
        // twoEndTime: formatDate(twoEndTime) || "",
        // threeEndTime: formatDate(threeEndTime) || "",
        oneStartTime: oneStartTime,
        twoStartTime: twoStartTime,
        threeStartTime: threeStartTime,
        oneEndTime: oneEndTime,
        twoEndTime: twoEndTime,
        threeEndTime: threeEndTime,
        oneWorkPlacewe: oneWorkPlace,
        twoWorkPlacewe: twoWorkPlace,
        threeWorkPlacewe: threeWorkPlace,
        oneWorkContent,
        twoWorkContent,
        threeWorkContent,
        fourStartTime: formatDate(fourStartTime) || "",
        fourEndTime: formatDate(fourEndTime) || "",
        fourWorkPlacewe: fourWorkPlace,
        fourWorkContent,
      };
      return workInfoData;
    },
    getEmployInfo() {
      const { employ } = this.$refs;
      const {
        checkedPosition,
        checkedEmployPlace,
        assignRadio,
        selectStandard,
        subjectAssignRadio,
      } = employ;
      let textArr = selectStandard.map((a) => a.text);
      textArr = textArr.map((it, index) => {
        const index_text =
          index === 0 ? "①" : index === 1 ? "②" : index === 2 ? "③" : "";
        return `${index_text}${it}；`;
      });
      const placeArr = checkedEmployPlace.map((it, index) => {
        const index_text =
          index === 0
            ? "First Choice："
            : index === 1
            ? "Second Choice："
            : "Third Choice：";
        it = `${index_text}${it}；`;
        return it;
      });
      const positionArr = checkedPosition.map((item, index) => {
        const index_text =
          index === 0
            ? "First Choice："
            : index === 1
            ? "Second Choice："
            : "Third Choice：";
        item = `${index_text}${item}`;
        return item;
      });
      const employInfoData = {
        gradesegmentSubjectText: positionArr.join("、"),
        //workingPlaceText: placeArr.join(' '),
        follow: assignRadio === 1 ? "YES" : "NO",
        subjectIsFollow: subjectAssignRadio === 1 ? "YES" : "NO",
        choiceStandard: textArr.join(" "),
      };
      return employInfoData;
    },
    validateForm() {
      let res = {}
      let validateRes = {
        res: true,
        msg: "",
      };
      const { baseInfo } = this.$refs;
      let {
        name,
        telephone,
        email,
        residentialAddress,
        telTypeValue
      } = baseInfo;
      if (!name) {
        $("#name").focus();
        return (validateRes = {
          ...validateRes,
          res: false,
          msg: "Please put your name!",
        });
      }
      // if (!sex) {
      //   $("#sex").focus();
      //   return (validateRes = {
      //     ...validateRes,
      //     res: false,
      //     msg: "请选择性别",
      //   });
      // }
      // if (!birthday) {
      //   $("#birthday").focus();
      //   return (validateRes = {
      //     ...validateRes,
      //     res: false,
      //     msg: "请选择出生年月",
      //   });
      // }
      // if (!nativePlace) {
      //   $("#nativePlace").focus();
      //   return (validateRes = {
      //     ...validateRes,
      //     res: false,
      //     msg: "请选择籍贯",
      //   });
      // }
      console.log('telTypeValue', telTypeValue)
      if (!telephone) {
        $("#telephone").focus();
        return (validateRes = {
          ...validateRes,
          res: false,
          msg: "Please put your mobile number!",
        });
      }
      // } else {
      //   if (telTypeValue === '+65') {
      //     if (!/^\d{8}$/.test(telephone)) {
      //       $("#telephone").focus();
      //       return (validateRes = {
      //         ...validateRes,
      //         res: false,
      //         msg: "Wrong Mobile Number format!",
      //       });
      //     }
      //   } else {
      //     if (!/^1[3456789]\d{9}$/.test(telephone)) {
      //       $("#telephone").focus();
      //       return (validateRes = {
      //         ...validateRes,
      //         res: false,
      //         msg: "Wrong Mobile Number format!",
      //       });
      //     }
      //   }
      // }
      // 手机号验证通过后拼接区号
      telephone = telTypeValue + telephone
      if (!email) {
        $("#email").focus();
        return (validateRes = {
          ...validateRes,
          res: false,
          msg: "Email Address!",
        });
      } else {
        if (!/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(email)) {
          $("#email").focus();
          return (validateRes = {
            ...validateRes,
            res: false,
            msg: "Wrong Email Address format!",
          });
        }
      }
      if (!residentialAddress) {
        $("#residentialAddress").focus();
        return (validateRes = {
          ...validateRes,
          res: false,
          msg: "Residential Address!",
        });
      }
      // if (!arrivalTime) {
      //   $("#arrivalTime").focus();
      //   return (validateRes = {
      //     ...validateRes,
      //     res: false,
      //     msg: "请选择到岗时间",
      //   });
      // }

      const { eduInfo } = this.$refs;
      const {
        degreeSchool,
        degreeStartDate,
        degreeEndDate,
        degreeMajor,
        list
      } = eduInfo;
      if (
        !(
          degreeSchool && degreeStartDate && degreeEndDate && degreeMajor
        )
      ) {
        return (validateRes = {
          ...validateRes,
          res: false,
          msg: "Please complete the mandatory field!",
        });
      }
      // let flag = false
      // Object.keys(list).forEach(i => {
      //   if (list[i].school === '' || list[i].startDate === '' || list[i].endDate === '' || list[i].major === '') {
      //     flag = true
      //   }
      // })
      // if (flag) {
      //   return (validateRes = {
      //     ...validateRes,
      //     res: false,
      //     msg: "Please complete the mandatory field!",
      //   })
      // }
      // res = {
      //   ...{
      //     name,
      //     telephone,
      //     email,
      //     residentialAddress,
      //     telTypeValue
      //   },
      //   ...{
      //     degreeSchool,
      //     degreeStartDate,
      //     degreeEndDate,
      //     degreeMajor,
      //     diplomaSchool,
      //     diplomaStartDate,
      //     diplomaEndDate,
      //     diplomaMajor
      //   }
      // }
      // if (list.length > 0) {
      //   res = {
      //     ...res,
      //     ...addList
      //   }
      // }
      // console.log('res', res)

      const { employ } = this.$refs;
      const {
        checkedPosition,
        checkedCoachSubject,
        checkedEmployPlace,
        selectStandard,
      } = employ;
      if (!checkedPosition.length) {
        $("#primary01").focus();
        return (validateRes = {
          ...validateRes,
          res: false,
          msg: "Please choose at least one Job Intention!",
        });
      }
      // if (!checkedEmployPlace.length) {
      //   $('#place01').focus()
      //   return validateRes = {...validateRes, res: false, msg: '至少选择一个期望就业地点'}
      // }
      if (selectStandard.length < 1) {
        return (validateRes = {
          ...validateRes,
          res: false,
          msg: "Please choose at least one Expectation Criteria!",
        });
      }

      // 验证应聘信息来源
      const infoSource = this.$refs.infoSource;
      if (!infoSource.checkedCities) {
        $("#checked1").focus();
        return (validateRes = {
          ...validateRes,
          res: false,
          msg: "Please choose the Application Source!",
        });
      }
      if (infoSource.checkedCities.includes("Internal")) {
        if (!infoSource.innerSourcePerson && !infoSource.recommendationcode) {
          $("#innerSourcePerson").focus();
          return (validateRes = {
            ...validateRes,
            res: false,
            msg: "Referred Person Name",
          });
        }
        if (!infoSource.innerSourcePhone && !infoSource.recommendationcode) {
          $("#innerSourcePhone").focus();
          return (validateRes = {
            ...validateRes,
            res: false,
            msg: "Referred Person Mobile Number",
          });
        }/* else {
          if (!/^1[3456789]\d{9}$/.test(infoSource.innerSourcePhone) && !infoSource.recommendationcode) {
            $("#innerSourcePhone").focus();
            return (validateRes = {
              ...validateRes,
              res: false,
              msg: "Wrong Referred Person Mobile Number Format",
            });
          }
        }*/
        // //验证内推码
        // if (infoSource.recommendationcode !== "") {
        //   return (validateRes = {
        //     ...validateRes,
        //     res: true,
        //     msg: "",
        //   });
        // }
      }

      // 验证是否勾选
      if (!this.isChecked) {
        return (validateRes = {
          ...validateRes,
          res: false,
          msg: "Please tick the declaration!",
        });
      }

      return validateRes;
    },
  },
  components: {
    FormTitle,
    InfoSource,
    BaseInfo,
    EduInfo,
    WorkInfo,
    Employ,
    CheckPhone,
    Achievement
    // CompetitionInfo
  },
};
</script>

<style lang="stylus">
@import '../common/stylus/mixin.styl';
@import '../common/stylus/variable.styl';
.submit-yes .el-dialog__header {
  display: none;
}
.imgbox {
  display: flex;
  align-items: center;
  height: 170px;

  .uploadimg {
    width: 100px;
    height: 100px;
    margin-right: 10px;
    border-radius: 50px;
    position: relative;
  }
}

.home-wrap {
  /*width: 100vw;
  height: 100vh;
  padding-bottom: 30px;
  overflow: scroll;*/

  .el-checkbox {
    color: #333;
  }

  .space {
    width: 1px;
    height: 1px;
  }

  .content {
    .header {
      width: 100%;

      .bg-header {
        width: 100%;
        height: 93px;
        line-height: 93px;
        text-align: center;
        font-size: 30px;
        bg-image('../assets/bg');
        background-size: 100% 93px;
        color: #fff;
      }

      .header-title {
        width: 100%;
        display: flex;

        .logo {
          flex: 1;
          height: 96px;
          line-height: 126px;
          text-align: left;

          .bg-logo {
            display: inline-block;
            vertical-align: middle;
            margin-right: 16px;
            width: 97px;
            height: 34px;
            bg-image('../assets/logo');
            background-size: 97px 34px;
          }

          .logo-text {
            display: inline-block;
            vertical-align: middle;
            border-left: 1px solid $theme-color;
            padding: 0 14px;
            height: 20px;
            line-height: 20px;
            text-align: center;
            font-size: 20px;
            color: $theme-color;
          }
        }

        .date {
          flex: 1;
          line-height: 126px;
          text-align: right;
          font-size: 14px;
          color: #333;
        }
      }
    }

    .form-content {
      width: 100%;
      margin-top: 33px;

      .upload-wrap {
        position: relative;
        margin-top: 48px;
        margin-bottom: 48px;

        .upload-tip {
          position: absolute;
          top: 7px;
          left: 159px;
        }

        p {
          margin: 0;
          padding: 0;
          color: #666;
          font-size: 12px;
        }

        .upload-btn {
          width: 146px;
          height: 48px;
          background-color: #007ab0;
          border-radius: 2px;
          font-size: 12px;
        }

        .upload-file {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 48px;
          opacity: 0;
        }
      }

      .file-list {
        margin-top: 15px;

        .text {
          font-size: 13px;
          color: #999;
        }
      }
    }

    .foot-btn-wrap {
      margin-top: 106px;

      .submit-btn {
        display: block;
        margin: 0 auto;
        width: 128px;
        height: 56px;
        background-color: #007AB0;
        font-size: 18px;
        color: #fff;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Home.vue